
import { Component, Prop, Vue } from 'vue-property-decorator'

import BacEllipsisLoader from '@/components/BacEllipsisLoader.vue'
import BacLazyImage from '@/components/BacLazyImage.vue'
import ChatMessageAudioComponent from './ChatMessageAudioComponent.vue'
import ChatMessageDocumentComponent from './ChatMessageDocumentComponent.vue'
import BacVideoPlayer from '@/components/BacVideoPlayer.vue'
import { ChatMessageWithDialog } from '../../lib/dtos/ChatMessageWithDialog'

import { ChatMessage } from '@/lib/chat/ChatMessage'
import { ChatAttachment } from '@/lib/chat/ChatAttachment'

import sanitizeHtml from 'sanitize-html'
import { StringUtils } from '@/lib/utils/StringUtils'

import { VProgressCircular } from 'vuetify/lib'
import { SerializationHelper } from '../../lib/utils/SerializationHelper'
import { Http } from '../../lib/utils/Http'

@Component({
  components: {
    BacEllipsisLoader,
    BacLazyImage,
    BacVideoPlayer,
    ChatMessageAudioComponent,
    ChatMessageDocumentComponent,
    VProgressCircular
  }
})
export default class ChatMessageComponent extends Vue {
  @Prop({ default: new ChatMessage() }) chatMessage!: ChatMessage;
  @Prop({ default: true }) showName!: boolean;
  @Prop({ default: false }) notSent!: boolean;
  @Prop({ required: false, default: false }) lazyLoad!: boolean;
  @Prop({ required: false, default: false }) prependLoading!: boolean;

  showDialog = false;
  showChevron = false;

  ChatAttachment = ChatAttachment;

  get chatMessageDeserialized () {
    return SerializationHelper.toInstance(
      new ChatMessageWithDialog(),
      this.chatMessage
    )
  }

  get isReallyNotSent () {
    if (this.notSent) {
      return true
    }
    for (let i = 0; i < this.chatMessage.attachments.length; i++) {
      if (
        this.chatMessage.attachments[i].source?.includes('/chat-messages/null')
      ) {
        return true
      }
    }
    return false
  }

  imageUrlCache: { name: string; size: number; url: string }[] = []; // file changes (e.g. uploaded bytes), the "cache" stops it from generating new URL's for each packet  send and so cause flickering in the screen
  getImageUrl (file: File) {
    const urlFromCache = this.imageUrlCache.find((cache) => {
      if (cache.name === file.name && cache.size === file.size) {
        return true
      }
    })
    if (urlFromCache) {
      return urlFromCache.url
    }

    const url = URL.createObjectURL(file)
    this.imageUrlCache.push({ name: file.name, size: file.size, url })

    return url
  }

  get messageContent () {
    let message = this.chatMessage.content
    if (!message) {
      message = ''
    }
    message = message.replace(/\\r\\n/g, '\r\n')
    message = StringUtils.linkify(message)
    return sanitizeHtml(message)
  }

  get statusIcon (): string {
    if (this.notSent) {
      return 'clock'
    }
    return 'check'
  }

  get usernameString () {
    if (this.chatMessage.user) {
      return `${this.chatMessage.user.firstname}`
    } else {
      return '...'
    }
  }

  get teamSiteLink () {
    if (this.chatMessage.team) {
      return `/team/${this.$route.params.rallyRoundId}/${
        (this.chatMessage.team as any).team_id
      }`
    } else {
      return '#'
    }
  }

  get teamString () {
    if (this.chatMessage.team) {
      return `#${this.chatMessage.team.number} ${this.chatMessage.team.name}`
    } else {
      return ''
    }
  }

  get time () {
    const date = new Date(this.chatMessage.createdAt)
    const hours = date.getHours()
    const minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes() // minutes with 0 in front if <10
    if (isNaN(hours) || !minutes) {
      return ''
    }
    return `${hours}:${minutes}`
  }

  get loggedInUserId () {
    if (this.$store.state.LoggedInUser.user) {
      return this.$store.state.LoggedInUser.user.id
    } else {
      return -1
    }
  }

  disableChevronTimeout () {
    clearTimeout(this.chevronTimeout)
  }

  chevronTimeout = 0;
  dontShowChevron () {
    this.chevronTimeout = setTimeout(() => {
      this.showChevron = false
    }, 500)
  }

  emitImageLoaded (element: HTMLImageElement) {
    setTimeout(() => {
      this.$emit('imageLoaded')
    }, 100)

    this.setImageSize(element)
  }

  setImageSize (image: HTMLImageElement) {
    if (!image || !image.naturalHeight) {
    }

    // image is clearly portrait
    // DEACTIVATED FOR NOW 6695458238
    /* if (image.naturalWidth < image.naturalHeight + 30) {
      image.style.width = '240px '
      if (image.parentElement) {
      }
    } */
  }

  async rotate (attachment: ChatAttachment, direction: string) {
    attachment.cacheParameter = Math.round(Math.random() * 1e9).toString()

    await Http.request(`/api/chat/posts/${attachment.id}/rotate/${direction}`, {
      method: 'put'
    })
  }
}
